import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface ErrorStateProps {
  routeCommunityId?: string;
  onNavigateBack: () => void;
}

export function ErrorState({ routeCommunityId, onNavigateBack }: ErrorStateProps) {
  return (
    <div className="container mx-auto py-10 text-center">
      <h2 className="text-xl font-semibold mb-2">Event not found</h2>
      <Button variant="outline" onClick={onNavigateBack}>
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to {routeCommunityId ? 'Events' : 'Home'}
      </Button>
    </div>
  );
}
